export const COMMIT_AUTHOR = 'commit_author';
export const COMMIT_DATE = 'commit_date';

export type CollectionProps = typeof COMMIT_AUTHOR | typeof COMMIT_DATE;
